import { Head, Link } from "@inertiajs/react"
import { AdminShell } from "@/components/AdminShell"
import { DestinationForm, type DestinationFormRecord, type ParentOption } from "./Form"

export default function AdminDestinationsEdit({
  destination,
  parent_options,
  kinds,
  statuses,
}: {
  destination: DestinationFormRecord
  parent_options: ParentOption[]
  kinds: string[]
  statuses: string[]
}) {
  return (
    <>
      <Head title={`Edit ${destination.name_en ?? "destination"}`} />
      <AdminShell>
        <div className="border-b border-hairline pb-6">
          <div className="flex flex-col gap-4 sm:flex-row sm:items-start sm:justify-between">
            <div>
              <h1>Edit destination</h1>
              <p className="mt-1">{destination.name_en ?? destination.name_de}</p>
            </div>
            <Link
              href={`/admin/destinations/${destination.id}`}
              className="text-sm text-ink-muted no-underline hover:text-ink-display"
            >
              Back to destination
            </Link>
          </div>
        </div>
        <DestinationForm
          destination={destination}
          parentOptions={parent_options}
          kinds={kinds}
          statuses={statuses}
          action={`/admin/destinations/${destination.id}`}
          method="patch"
          submitLabel="Save destination"
        />
      </AdminShell>
    </>
  )
}
